<app-page-heading [heading]="'Data Center'" [hasBackButton]="false"></app-page-heading>

<mat-tab-group class="tab-container"
               [(selectedIndex)]="activeTabIndex"
               (selectedTabChange)="onTabSelectionChanged($event)">
  
  <mat-tab label="Member Data">
    <ng-template matTabContent>
      <app-member-data-view></app-member-data-view>
    </ng-template>
  </mat-tab>
  
  <mat-tab label="External Data">
    <ng-template matTabContent>
      <app-external-data-view></app-external-data-view>
    </ng-template>
  </mat-tab>
</mat-tab-group>
